var React = require("react");
const PropTypes = require('prop-types');

var Checkbox = function (props) {
	var classes = "checkbox";
	if (props.disabled === true) {
		classes += " disabled";
	}
	return (
		<div className={classes} >
			<label htmlFor={props.name + props.id}>
				<input
					onChange={props.onClick}
					type="checkbox"
					name={props.name + props.id}
					id={props.name + props.id}
					value={props.id}
					checked={props.checked}
					disabled={(props.disabled === true)}
				/>
				{props.description}
			</label>
		</div>
	);
};

Checkbox.propTypes = {
	id: PropTypes.number.isRequired,
	name:  PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool
};

module.exports = Checkbox;
